import toast from 'react-hot-toast';

export  const notify = (errorText) => toast(
    <div className='text-center'>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
            <path d="M2.43004 17.5241H17.9586C18.6954 17.5241 19.3553 17.1432 19.7237 16.5052C20.0921 15.8672 20.0921 15.1053 19.7237 14.4673L11.9594 1.01893C11.591 0.380925 10.9311 0 10.1943 0C9.45755 0 8.7976 0.380925 8.42921 1.01893L0.664934 14.4673C0.296549 15.1053 0.296549 15.8672 0.664934 16.5052C1.03332 17.1432 1.69327 17.5241 2.43004 17.5241ZM10.1943 0.940555C10.5909 0.940555 10.9468 1.14591 11.1443 1.48921L18.9086 14.9376C19.1061 15.2809 19.1061 15.6916 18.9086 16.0349C18.7095 16.3782 18.3552 16.5836 17.9586 16.5836H2.43004C2.03344 16.5836 1.6776 16.3782 1.48008 16.0349C1.281 15.6916 1.281 15.2809 1.48008 14.9376L9.24436 1.48921C9.44188 1.14591 9.79772 0.940555 10.1943 0.940555Z" fill="#FF2B2B"/>
            <path d="M10.1938 14.3923C10.454 14.3923 10.6641 14.1823 10.6641 13.922V13.1382C10.6641 12.878 10.454 12.668 10.1938 12.668C9.93356 12.668 9.72351 12.878 9.72351 13.1382V13.922C9.72351 14.1823 9.93356 14.3923 10.1938 14.3923Z" fill="#FF2B2B"/>
            <path d="M10.1938 11.2527C10.454 11.2527 10.6641 11.0426 10.6641 10.7824V6.07965C10.6641 5.81943 10.454 5.60938 10.1938 5.60938C9.93356 5.60938 9.72351 5.81943 9.72351 6.07965V10.7824C9.72351 11.0426 9.93356 11.2527 10.1938 11.2527Z" fill="#FF2B2B"/>
        </svg>
        <p className='toast-notify'>{errorText}</p>
    </div>
  , {
    style: {
      border: '2px solid #FF2B2B',
      borderRadius: '10px',
      color: '#FF2B2B',
      background: "#FFF3F3"
    },
  });

export  const positiveNotify = (errorText) => toast.success(
    <div className='text-center mt-4'>
        <p>{errorText}</p>
    </div>
    , {
        style: {
            border: '2px solid #33ba39',
            borderRadius: '10px',
            color: '#33ba39',
            background: "#edffee"
        },
});